import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../api/client';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    if (!token) {
        setValidating(false);
        setError('Invalid link: missing token.');
        return;
    }
    // Validate token on load
    api.get(`/auth/password-reset/validate?token=${token}`)
       .then(() => setValidating(false))
       .catch((err: any) => {
           setValidating(false);
           setError(err.response?.data?.message || 'Invalid or expired link.');
       });
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return;
    setBusy(true);
    setMessage('');
    setError('');
    try {
      const res = await api.post('/auth/password-reset', { token, newPassword });
      setMessage(res.data?.message || 'Password reset successful.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Reset failed.');
    } finally {
      setBusy(false);
    }
  };

  if (validating) return <div className="container mt-5">Validating link...</div>;
  if (error) return (
    <div className="container mt-5">
        <h3 className="text-danger">Error</h3>
        <p>{error}</p>
        <button className="btn btn-secondary mt-3" onClick={() => navigate('/forgot-password')}>Request New Link</button>
    </div>
  );

  return (
    <div className="container mt-5" role="main">
      <h2>Reset Password</h2>
      <p className="text-muted">Enter your new password below.</p>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="passwordInput" className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            id="passwordInput"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            autoFocus
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={busy}>
          {busy ? 'Resetting…' : 'Reset Password'}
        </button>
      </form>
      {message && <p className="mt-3 text-success" aria-live="polite">{message}</p>}
    </div>
  );
};

export default ResetPassword;
